import { IconComponentProps } from '../IconTypes';

const Acceptance = ({ className }: IconComponentProps) => (
  <svg
    className={className}
    fill="currentColor"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.43293 4.26921C8.67668 4.02507 9.07238 4.02507 9.31652 4.26921L10.9591 5.90796L14.6833 2.18296C14.9271 1.93882 15.3228 1.93921 15.5669 2.18296C15.8111 2.42671 15.8111 2.82241 15.5669 3.06655L11.3989 7.23452C11.277 7.35663 11.1134 7.41765 10.9571 7.41765C10.8009 7.41765 10.6407 7.35515 10.5165 7.23601L8.43293 5.1528C8.18879 4.90905 8.18918 4.51335 8.43293 4.26921Z"
      fill="currentColor"
    />
    <path
      clipRule="evenodd"
      d="M4.54892 10.4886C3.16821 10.4886 2.04892 11.6079 2.04892 12.9886V19.4886C2.04892 20.8694 3.16821 21.9886 4.54892 21.9886H10.0489C11.4296 21.9886 12.5489 20.8694 12.5489 19.4886V12.9886C12.5489 11.6079 11.4296 10.4886 10.0489 10.4886H4.54892ZM5.04889 11.7386H4.54892C3.85856 11.7386 3.29892 12.2983 3.29892 12.9886V19.4886C3.29892 20.179 3.85856 20.7386 4.54892 20.7386H10.0489C10.7393 20.7386 11.2989 20.179 11.2989 19.4886V12.9886C11.2989 12.2983 10.7393 11.7386 10.0489 11.7386H9.54889V13.7217C9.54889 14.9643 8.54153 15.9717 7.29889 15.9717C6.05625 15.9717 5.04889 14.9643 5.04889 13.7217V11.7386ZM8.29889 11.7386H6.29889V13.7217C6.29889 14.274 6.7466 14.7217 7.29889 14.7217C7.85117 14.7217 8.29889 14.274 8.29889 13.7217V11.7386Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.4911 12.4886H19.4911C20.8718 12.4886 21.9911 13.6079 21.9911 14.9886V19.4886C21.9911 20.8694 20.8718 21.9886 19.4911 21.9886H16.4911C15.1103 21.9886 13.9911 20.8694 13.9911 19.4886V14.9886C13.9911 13.6079 15.1103 12.4886 16.4911 12.4886ZM16.4911 13.7386C15.8007 13.7386 15.2411 14.2983 15.2411 14.9886V19.4886C15.2411 20.179 15.8007 20.7386 16.4911 20.7386H19.4911C20.1814 20.7386 20.7411 20.179 20.7411 19.4886V14.9886C20.7411 14.2983 20.1814 13.7386 19.4911 13.7386H16.4911Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

export default Acceptance;
